// src/api/profile/useVerifyCodeChangeNumber .ts

import Api from "../generalApi/Api";
import { GeneralResponse } from "../../interface/GeneralResponse";
import { useMutation } from "@tanstack/react-query";
import { useToast } from "../../Services/ToastContext";
import { EndPoints } from "../../Constants/endpoints";
import { Methods } from "../../Constants/ApiConstants";

import { string } from "zod";
import { useTranslation } from "react-i18next";

export interface VerifyCodeChangeNumberRequest {
  Id: number;
  CountryId: number | undefined;
  PhoneNumber: string;
  VerificationCode: string;
}

const useVerifyCodeChangeNumber = () => {
  const { showToast } = useToast();
  
    const {t} = useTranslation()
  const mutation = useMutation({
    mutationFn: (
      data: VerifyCodeChangeNumberRequest,
    ): Promise<GeneralResponse> => {
      return Api<VerifyCodeChangeNumberRequest, GeneralResponse>({
        method: Methods.POST,
        endpoint: EndPoints.verifyingCodeForNewNumber,
        body: data,
      });
    },
    onSuccess: (data) => {
      if (data.Status) {
        showToast(t("phone_number_changed_successfully"), "success");
        // Optionally, navigate to verification step or another page
      } else {
        showToast(data.ErrorMessage || t("something_went_wrong"), "error");
      }
    },
    onError: (error: any) => {
      showToast(error.response?.data?.message || error.message, "error");
    },
  });

  return mutation;
};

export default useVerifyCodeChangeNumber;
